import { Timestamp } from "firebase/firestore";

export const toDateTimeString = (timestamp?: Timestamp) => {
  if (!timestamp) return " - ";
  return new Date(timestamp.seconds * 1000).toLocaleString([], {
    dateStyle: "medium",
    timeStyle: "short",
  });
};
